import { FC, HTMLAttributes, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import { Layout } from 'antd';
import cn from 'classnames';

import { useRedirectToCreateAdspace } from 'entities/Adspace';
import { JoinBrand, JoinBrandModal, JoinInviteBrand } from 'entities/Brand';
import { JoinInviteOffer, JoinOffer, OfferDetailDrawer } from 'entities/Offer';
import { ConnectSource } from 'features/ConnectSource';
import { useSetLocalStorageFilters } from 'features/Filters';
import { useGetAppConfigQuery, useGetMetaQuery } from 'shared/api';
import { useSendPageViewEvent } from 'shared/hooks';
import { OverlayLoader } from 'shared/ui';
import { Alerts } from 'widgets/Alerts';
import { Footer } from 'widgets/Footer';
import { Header } from 'widgets/Header';
import { Sidebar } from 'widgets/Sidebar';

import styles from './MainLayout.module.scss';

interface IMainLayoutProps extends HTMLAttributes<HTMLDivElement> {
	outlet?: ReactNode;
}

export const MainLayout: FC<IMainLayoutProps> = ({ className, outlet, ...props }) => {
	const { data: appConfig, isFetching } = useGetAppConfigQuery();

	useGetMetaQuery();
	useRedirectToCreateAdspace();
	useSendPageViewEvent();
	useSetLocalStorageFilters();

	return (
		<Layout {...props} className={cn(className, styles.main)} style={{ minHeight: '100vh' }}>
			{(isFetching || !appConfig?.user) && <OverlayLoader opacity={1} zIndex={101} />}
			<Sidebar />
			<Layout>
				<Header />
				<Layout.Content className={styles.content}>{outlet || <Outlet />}</Layout.Content>
				<Footer />
			</Layout>
			<Alerts />
			<OfferDetailDrawer />
			<JoinOffer />
			<JoinInviteOffer />
			<JoinBrand />
			<JoinInviteBrand />
			<JoinBrandModal />
			<ConnectSource />
		</Layout>
	);
};
